"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoardName = void 0;
var BoardName;
(function (BoardName) {
    BoardName["THARSIS"] = "tharsis";
    BoardName["HELLAS"] = "hellas";
    BoardName["ELYSIUM"] = "elysium";
    BoardName["UTOPIA_PLANITIA"] = "utopia planitia";
    BoardName["VASTITAS_BOREALIS_NOVUS"] = "vastitas borealis novus";
    BoardName["TERRA_CIMMERIA_NOVUS"] = "terra cimmeria novus";
    BoardName["ARABIA_TERRA"] = "arabia terra";
    BoardName["VASTITAS_BOREALIS"] = "vastitas borealis";
    BoardName["AMAZONIS"] = "amazonis p.";
    BoardName["TERRA_CIMMERIA"] = "t. cimmeria";
    BoardName["HOLLANDIA"] = "Hollandia";
})(BoardName = exports.BoardName || (exports.BoardName = {}));
